import { useUnit } from 'effector-react';
import { $pathname } from 'models/location';
import navigate from 'models/router-gate';
import { useEffect } from 'react';

import { Button } from 'components/StyledTemplates/StyledTemplates';
import LoadingPage from 'components/pages/LoadingPage/LoadingPage';

import ModalsService from 'services/ModalsService';

import useResources from 'hooks/useResources';

const ChangeRoleWarningPage = () => {
    const { t, evaluate } = useResources();
    const isToAdvisor = useUnit($pathname.map((pathname) => pathname.startsWith('/advisor')));

    useEffect(() => {
        ModalsService.showModality(
            evaluate(t('changeRolePage.modality.title'), { isToAdvisor }),
            evaluate(t('changeRolePage.modality.description'), { isToAdvisor }),
            {
                confirmButton: t('changeRolePage.modality.buttons.close'),
                onConfirm: async () => {
                    navigate(isToAdvisor ? '/dashboard' : '/advisor/dashboard');
                },
                displayCloseButton: false,
            },
        );
    }, []);

    return (
        <LoadingPage>
            <Button onClick={() => navigate(-2)}>Back</Button>
        </LoadingPage>
    );
};

export default ChangeRoleWarningPage;
